import { Component, Input } from '@angular/core'
import { CardComponent } from '../../card'
import { Illustration, IllustrationComponent } from '../../illustration'

@Component({
  selector: 'ftr-empty-items',
  templateUrl: './empty-items.component.html',
  styleUrls: ['./empty-items.component.css'],
  imports: [IllustrationComponent, CardComponent],
  standalone: true,
})
export class EmptyItemsComponent {
  @Input() illustration: Illustration
  @Input() entityName = 'items'
}
